// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3KJj7","row":"Node_row__14PBl","label":"Node_label__1xEP2","footer":"Node_footer__28f4z"};